import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
// import { cityDb } from './temp/m-city-export';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: 'AIzaSyBHKg1KxcIShcFdP8x8S_Pj-V1tgPgZucE',
    authDomain: 'football-club-546ab.firebaseapp.com',
    projectId: 'football-club-546ab',
    storageBucket: 'football-club-546ab.appspot.com',
    messagingSenderId: '244491894431',
    appId: '1:244491894431:web:07738827bdd0b48125acaa',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const DB = firebase.firestore();
const mathchesCollection = DB.collection('matches');
const playersCollection = DB.collection('players');
const positionsCollection = DB.collection('positions');
const promotionsCollection = DB.collection('promotions');
const teamsCollection = DB.collection('teams');

// cityDb.matches.forEach(item => {
//     mathchesCollection.add(item);
// });

// cityDb.players.forEach(item => {
//     playersCollection.add(item);
// });

// cityDb.positions.forEach(item => {
//     positionsCollection.add(item);
// });

// cityDb.promotions.forEach(item => {
//     promotionsCollection.add(item);
// });

// cityDb.teams.forEach(item => {
//     teamsCollection.add(item);
// });

export {
    firebase,
    mathchesCollection,
    playersCollection,
    positionsCollection,
    promotionsCollection,
    teamsCollection,
};
